/*
 * 비밀번호 규칙.
 *
 * 서버(CRM.API/Helpers/PasswordPolicy.cs)와 같은 잣대를 쓴다.
 * 화면에서 먼저 걸러 주면 사용자가 저장을 눌러 보고서야 알게 되는 일이 없다.
 * 최종 판단은 언제나 서버가 한다.
 */

export const PASSWORD_MIN_LENGTH = 8;

/** 입력칸 아래에 그대로 띄우는 안내 문구. */
export const PASSWORD_RULE_TEXT =
  '숫자와 문자를 섞어 8자 이상 (특수문자 사용 가능)';

/**
 * 규칙에 맞는지 본다.
 * @returns {string} 문제가 없으면 빈 문자열, 있으면 사람이 읽을 사유
 */
export const validatePassword = (value) => {
  const password = value ?? '';

  if (password.length < PASSWORD_MIN_LENGTH) {
    return `비밀번호는 ${PASSWORD_MIN_LENGTH}자 이상이어야 합니다.`;
  }

  const hasDigit = /\d/.test(password);
  // 숫자가 아닌 글자는 모두 '문자'로 본다(영문·한글·특수문자). 서버와 같은 기준이다.
  const hasNonDigit = /[^\d\s]/.test(password);

  if (!hasDigit || !hasNonDigit) {
    return '비밀번호는 숫자와 문자를 함께 써야 합니다. (특수문자 사용 가능)';
  }

  return '';
};

/** 규칙을 만족하는가. */
export const isPasswordValid = (value) => validatePassword(value) === '';
